export default "__VITE_ASSET__BY54l6MA__"